import React from 'react';
import { Col, Form, Input, Row, TimePicker } from 'antd';
import { useTranslation } from 'react-i18next';
import './PickupForm.scss';
import { TIME_FORMAT } from '../../../constants';
import PhoneInput from 'react-phone-input-2';
import AddressInput from '../../Inputs/AddressInput';
import isEmpty from 'lodash/isEmpty';

const PickupForm = ({ form }) => {
  const { t } = useTranslation('orders');

  const handleOnChangePickupFrom = (value) => {
    form.setFieldsValue({ pickupTimeStart: value });
    if (isEmpty(value) || isEmpty(form.getFieldValue('pickupTimeEnd'))) {
      resetErrorPickupTime();
      return;
    }
    if (form.getFieldValue('pickupTimeEnd') < value) {
      form.setFields([
        {
          name: 'pickupTimeStart',
          errors: [t('form.shiftEndError')],
        },
      ]);
    }
  };

  const handleOnChangePickupTo = (value) => {
    form.setFieldsValue({ pickupTimeEnd: value });
    if (isEmpty(value) || isEmpty(form.getFieldValue('pickupTimeStart'))) {
      resetErrorPickupTime();
      return;
    }
    if (form.getFieldValue('pickupTimeStart') > value) {
      form.setFields([
        {
          name: 'pickupTimeEnd',
          errors: [t('form.pickupToError')],
        },
      ]);
    }
  };

  const resetErrorPickupTime = () => {
    form.setFields([
      {
        name: 'pickupTimeStart',
        errors: [],
      },
      {
        name: 'pickupTimeEnd',
        errors: [],
      },
    ]);
  };

  return (
    <div className={`PickupForm`}>
      <Row gutter={24}>
        <Col span={6}>
          <Form.Item
            label={t('form.pickupName')}
            name="pickupName"
            rules={[{ required: true, message: t('common:required') }]}
          >
            <Input placeholder={t('form.pickupName')} />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item label={t('form.pickupPhone')} name="pickupPhone">
            <PhoneInput country={'ch'} specialLabel="" prefix="+" countryCodeEditable enableSearch disableSearchIcon />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item label={t('form.pickupFrom')} name="pickupTimeStart">
            <TimePicker
              placeholder={t('form.pickupFrom')}
              format={TIME_FORMAT}
              minuteStep={30}
              style={{ width: '100%' }}
              onChange={handleOnChangePickupFrom}
              onSelect={handleOnChangePickupFrom}
            />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item label={t('form.pickupTo')} name="pickupTimeEnd">
            <TimePicker
              placeholder={t('form.pickupTo')}
              format={TIME_FORMAT}
              minuteStep={30}
              style={{ width: '100%' }}
              onChange={handleOnChangePickupTo}
              onSelect={handleOnChangePickupTo}
            />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
            label={t('form.pickupEmail')}
            name="pickupEmail"
            rules={[{ type: 'email', message: t('common:invalidEmail') }]}
          >
            <Input placeholder={t('form.pickupEmail')} />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            label={t('form.pickupAddress')}
            name="pickupAddress"
            rules={[
              {
                validator: (_, value) => {
                  if (value?.address && value?.latLng?.lat && value?.latLng?.lng) {
                    return Promise.resolve();
                  }

                  if (isEmpty(value?.address)) {
                    return Promise.reject(new Error(t('common:required')));
                  }

                  return Promise.reject(new Error(t('common:invalid')));
                },
              },
            ]}
          >
            <AddressInput
              placeholder={t('form.pickupAddress')}
              onSelect={(value) => form.setFieldsValue({ pickupAddress: value })}
            />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item label={t('form.pickupDuration')} name="pickupDuration">
            <Input placeholder={t('form.pickupDuration')} suffix={t('common:minutes')} />
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item name="pickupNote" label={t('form.pickupNote')}>
            <Input.TextArea placeholder={t('common:note')} />
          </Form.Item>
        </Col>
      </Row>
    </div>
  );
};

export default PickupForm;
